<template>
  <v-container>
    <v-dialog v-model="dialog" width="600px">
      <template v-slot:activator="{ props: activatorProps }">
        <slot name="activator" :props="activatorProps">
          <slot name="action" :props="activatorProps">
            <v-icon class="standard-log__activator" color="primary" v-bind="activatorProps">
              mdi-file-document
            </v-icon>
          </slot>
        </slot>
      </template>

      <slot name="data" :log="log">
        <v-card>
          <v-card-title v-if="title">{{ title }}</v-card-title>
          <v-card-text v-if="log.length">
            <div v-for="(task, index) in log" :key="index">
              <div>
                <div class="time">{{ task[0].timecreated }}</div>
                <div v-for="(logRecord, index0) in task" :key="index0" class="message">
                  {{ logRecord.other.message }}
                  <span v-if="actorName(logRecord)" class="actor">
                    {{ actorName(logRecord) }}
                  </span>
                </div>
              </div>
              <v-divider v-if="index != log.length - 1" />
            </div>
          </v-card-text>
          <v-skeleton-loader v-else type="article"></v-skeleton-loader>
          <v-card-actions>
            <v-spacer />
            <v-btn class="standard-log__close" color="primary" variant="flat" @click="dialog = false">
              Закрыть
            </v-btn>
          </v-card-actions>
        </v-card>
      </slot>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  props: {
    target: {
      type: String,
      default: ''
    },
    objecttable: {
      type: String,
      default: ''
    },
    crud: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      log: [],
      dialog: false,
    };
  },
  created() {
  },
  watch: {
    dialog(visible) {
      if (visible && this.target) {
        this.getLog();
      }
    },
  },
  methods: {
    getLog() {
      this.log = [];
      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/core_procollege/helpers/rest/getStandardLog",
          new URLSearchParams({
            target: this.target,
            objecttable: this.objecttable,
            crud: this.crud
          })
        )
        .then((response) => {
          if (response.data.length == 0) {
            this.log[""] = [{ timecreated: "", other: { message: "Нет данных" } }];
          } else {
            //в одно время может быть несколько записей, поэтому группируем по времени создания
            response.data.forEach((element) => {
              if (this.log[element.timecreated] == undefined) {
                this.log[element.timecreated] = [];
              }
              this.log[element.timecreated].push(element);
            });
          }
          this.log = Object.values(this.log);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    actorName(logRecord) {
      return [logRecord.actor_firstname, logRecord.actor_lastname]
        .filter(Boolean)
        .join(' ');
    },
  },
};
</script>
<style lang="css" scoped>
.message {
  font-size: 12pt;
  color: darkslateblue;
  border: none;
}

.actor {
  display: block;
  margin-top: 2px;
  color: #667085;
  font-size: 12px;
}

.standard-log__activator,
.standard-log__close {
  cursor: pointer;
}
</style>
